var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table',{staticClass:"table-list-noborder"},_vm._l((_vm.qa.rules.table),function(t){return _c('tr',[_c('td',[_vm._v(_vm._s(t))]),_c('td',[_c('inspect-dropdown',{attrs:{"qa":_vm.qa,"report":_vm.report,"value":_vm.value,"index":t},on:{"updateValue":_vm.updateValue}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }